export enum AircraftCategoryNameEnum {
  LIGHT = 'Light Jet',
  SUPER_MID_SIZE = 'Super Mid Size Jet',
  TURBOPROP = 'Turboprop Jet',
  MID_SIZE = 'Mid Size Jet',
  HEAVY = 'Heavy Jet',
  ULR = 'ULR Jet'
}
